import React from "react";

const ones = [
    "", "One", "Two", "Three", "Four", "Five", "Six",
    "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
    "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
];

const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty",
    "Sixty", "Seventy", "Eighty", "Ninety"
];

function numberToWords(num: number): string {
    if (num === 0) return "Zero";

    if (num < 20) return ones[num];
    if (num < 100) {
        return tens[Math.floor(num / 10)] + (num % 10 ? " " + ones[num % 10] : "");
    }
    if (num < 1000) {
        return ones[Math.floor(num / 100)] + " Hundred" + (num % 100 ? " " + numberToWords(num % 100) : "");
    }
    if (num < 1000000) {
        return numberToWords(Math.floor(num / 1000)) + " Thousand" + (num % 1000 ? " " + numberToWords(num % 1000) : "");
    }
    if (num < 1000000000) {
        return numberToWords(Math.floor(num / 1000000)) + " Million" + (num % 1000000 ? " " + numberToWords(num % 1000000) : "");
    }
    return "Number too large";
}

function amountToWords(value: number, currency: string): string {
    const whole = Math.floor(value);
    const fraction = Math.round((value % 1) * 100);

    let words = numberToWords(whole) + " " + currency;
    if (fraction > 0) {
        words += " and " + numberToWords(fraction) + " Cents";
    }

    return value > 0 ? words : '';
}

interface Props {
    value?: number;
    currencyCode?: string;   // e.g. PKR
    currencyName?: string;   // e.g. Pakistani Rupees
    amountInWord?: boolean;
    strong?: boolean;
}

const AmountFormat: React.FC<Props> = ({
    value,
    currencyCode,
    currencyName = "",
    amountInWord = false,
    strong = true
}) => {
    const formattedValue = `${value == null || value == undefined ? "-" : value.toLocaleString()} ${currencyCode ?? ""}`;

    return (
        <span>
            {strong ? (
                <strong>{formattedValue}</strong>
            ) : (
                <span>{formattedValue}</span>
            )}
            {value != undefined && value > 0 && amountInWord && (
                <div style={{ fontSize: "12px", color: "#888", marginLeft: "5px" }}>
                    ({amountToWords(value, currencyName)})
                </div>
            )}
        </span>
    );
};

export default AmountFormat;
